import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Store,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/stores`;

const getStoreBySellerId = async ({
  sellerId,
}: {
  sellerId: string;
}): Promise<BackResponse<Store[]> | BackResponseFailure> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const response = await apiCall<BackResponse<Store[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getStoreBySellerId;
